import { IMAGES } from "../data";
import { Reveal } from "./Reveal";

const shots = [
  { src: IMAGES.climbing2, label: "Technical Climb", span: "lg:col-span-7 aspect-[16/11]" },
  { src: IMAGES.chainsaw, label: "Precision Cutting", span: "lg:col-span-5 aspect-[16/11]" },
  { src: IMAGES.boomlift, label: "Elevation & Trimming", span: "lg:col-span-5 aspect-[4/3]" },
  { src: IMAGES.landscape, label: "Property Refresh", span: "lg:col-span-7 aspect-[4/3]" },
];

export const Gallery = () => (
  <section id="work" data-testid="gallery" className="bg-bone py-24 md:py-32">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10">
      <div className="flex items-center gap-3 mb-5">
        <span className="h-[1px] w-10 bg-terra" />
        <span className="text-pine/60 text-xs uppercase tracking-[0.3em]">On the job</span>
      </div>
      <Reveal>
        <h2 className="font-display font-extrabold text-pine tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[0.95] max-w-3xl mb-14">
          Real work. Real properties. Left better than we found them.
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 md:gap-6">
        {shots.map((s, i) => (
          <Reveal key={i} delay={(i % 2) * 0.1} className={s.span}>
            <div className="img-clip relative h-full w-full border border-stone group">
              <img src={s.src} alt={s.label} className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-obsidian/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <span className="absolute bottom-5 left-5 text-bone font-display font-bold text-lg tracking-tight opacity-0 translate-y-3 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500">
                {s.label}
              </span>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
